<template>
  <div class="auth-tips-top"
       data-sensors-exposure-property-caseid="withdraw_tips"
       data-sensors-exposure-event-name="Element_Exposure"
  >
    <img src="./icon_pinggu@2x.png">
    <p>{{ msg }}</p>
  </div>
</template>
<script>
export default {
  name: 'auth-tips-top', 
  props: ['msg'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.auth-tips-top {
  display: flex;
  width: 670px;
  height: 80px;
  background: #22274c;
  border: 1px solid rgba(255, 255, 255, 0.25);
  align-items: center;
  position: relative;
  border-radius: 20px;
  padding-left: 20px;
  margin: 20px auto -20px;
  padding-bottom: 15px;
  &.mt0 {margin-top: 0;}
  p {
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #cccccc;
    line-height: 33px;
  }
  img {
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.1rem;
    vertical-align: -10px;
  }
}
</style>